export default [
    // -------------------------------------------------------管理员--------------------------------------------------------------------------//
    {
        label: "待处理告警",
        authority: ["partner"],
        name: "admin-pend-warning",
        icon: "okp-real-time-alarm",
    },
    {
        label: "站点管理",
        authority: ["partner"],
        name: "admin-site-managing",
        icon: "okp-zhandiandizhi",
    },
    {
        label: "人员管理",
        authority: ["partner"],
        name: "admin-person-managing",
        icon: "okp-renyuanguanli",
    },
    {
        label: "服务授权",
        authority: ["partner"],
        name: "admin-server-authorization",
        icon: "okp-shouquan2",
    },
    {
        label: "通知规则",
        authority: ["partner"],
        name: "admin-notice-rule",
        icon: "okp-fabubiaoshu",
    },
    {
        label: "工单",
        authority: ["partner"],
        items: [
            {
                label: "处理中工单",
                name: "admin-process-workList",
                icon: "okp-order-pending",
            },
            {
                label: "待指派工单",
                name: "admin-dealing-workList",
                icon: "okp-order-track",
            },
            {
                label: "已关闭工单",
                name: "admin-close-workList",
                icon: "okp-gongdanqueren",
            }
        ],
    },
    // -------------------------------------------------------用户--------------------------------------------------------------------------//
    {
        label: "告警",
        authority: ["user"],
        items: [
            {
                label: "待处理告警",
                name: "user-pend-warning",
                icon: "okp-real-time-alarm",
            },
            {
                label: "告警列表",
                name: "user-warning-list",
                icon: "okp-yidongyunkongzhitaiicon69",
            },
        ],
    },
    {
        label: "通知",
        authority: ["user"],
        items: [
            {
                label: "通知列表",
                name: "user-notice-rule",
                icon: "okp-xiaoxi1",
            },
            {
                label: "通知规则",
                name: "user-notice-list",
                icon: "okp-fabubiaoshu",
            },
        ],
    },
    {
        label: "工单",
        authority: ["user"],
        items: [
            {
                label: "处理中工单",
                name: "user-process-workList",
                icon: "okp-order-pending",
            },
            {
                label: "已关闭工单",
                name: "user-close-workList",
                icon: "okp-gongdanqueren",
            },
            {
                label: "新建工单",
                name: "user-new-workList",
                icon: "okp-zaixiangongdan",
            },
        ],
    },
    {
        label: "工具体验",
        authority: ["user"],
        items: [
            {
                label: "巡检报告",
                name: "user-comprehensive-inspection",
                icon: "okp-shujuxunjianbaogao",
            },
            {
                label: "AWR报告解读",
                name: "user-awr-unscramble",
                icon: "okp-baogaojiedu",
            },
        ],
    },
    //----------------------------------------------------超管----------------------------------------------------------------//
    // {
    //     label: "数据总览",
    //     authority: ["oneKeeper"],
    //     name: "partner-count",
    //     icon: "okp-zhandiandizhi",
    // },
    {
        label: "合作伙伴",
        authority: ["oneKeeper"],
        name: "parnter",
        icon: "okp-zhandiandizhi",
    },
]